export default __webpack_public_path__ + "static/media/ValidCertificate.9047ddaf.png";